import InputForm from "../../Components/InputForm/InputForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { LoaderContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import {
  CommonDropdownData,
  loanModuleGetPersonalDetailsByMemberId,
} from "../../Helpers/APIEndPoints/EndPoints";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useSelector } from "react-redux";
import {
  GenericMasterType,
  LoanTypeEnum,
  MODES,
} from "../../Helpers/Enums/Enum";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { RiFileListLine } from "react-icons/ri";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import ApprovalModal from "../Common/ApprovalModal/ApprovalModal";
import { Modules } from "../../Helpers/Enums/Modules";

const LoanDetailApproval = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { state } = useLocation();
  let navigate = useNavigate();

  const [additionalAmount, setAdditionalAmount] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState<any>({});
  const [disabledReason, setDisabledReason] = useState(false);
  const [forLongTermDisabled, setForLongTermDisabled] = useState(false);
  const [reason, setReason] = useState({});
  const [reasonOption, setReasonOption] = useState([]);
  const [loanAmount, setLoanAmount] = useState();
  const [installments, setInstallments] = useState();
  const [memberNumber, setMemberNumber] = useState();
  const [RateOfInterest, setRateOfInterest] = useState();
  const [loanRequestId, setLoanRequestId] = useState();
  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};
  let { selectNextTab } = props;
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [formDataOnEdit, setFormDataOnEdit] = useState<any>();
  const [loanType, setLoanType] = useState<any>();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const loanParameters = useSelector<any>(
    (state) => state?.LoanModuleReducer?.loanParameters
  );
  const [AdditionalLoanParameter, setAdditionalLoanParameter] = useState<any>({
    AdditionalAmount: "0",
    LoanId: "0",
    MemberId: "0",
  });
  const [AdditionalLoanAmount, setAdditionalLoanAmount] = useState<any>();
  const [AdditionalLoanROI, setAdditionalLoanROI] = useState();

  const [isResetClicked, setIsResetClicked] = useState<any>(false);

  const [AdditionalGiveableLoanAmount, setAdditionalGiveableLoanAmount] = useState<any>();
  const [GiveableLoanAmount, setGiveableLoanAmount] = useState<any>();
  const open = Boolean(anchorEl);

  useEffect(() => {
    getPersonalDetailsByIdApiCallll();
    if (isResetClicked) {
      getDropDownDataApiCall();
    }
  }, [isResetClicked]);

  useEffect(() => {
    if (reasonOption.length > 0 && formDataOnEdit != "") {
      let val = reasonOption.find((ele) => ele.value == formDataOnEdit);
      setReason(val);
    }
  }, [reasonOption, formDataOnEdit]);

  const getDropDownDataApiCall = async () => {
    showLoader();
    let requestParams = {
      dropdownName: "generic",
      GenericMasterTypeId:
        loanType == LoanTypeEnum.SHORTTERM
          ? GenericMasterType.SHORTTERM
          : GenericMasterType.LONGTERM, // short term
    };

    const res = await APICall(CommonDropdownData, requestParams);
    if (res && res?.Data?.length > 0) {
      let options = res.Data;
      setReasonOption(options);
      hideLoader();
    } else {
      setReasonOption([]);
      notify(ToastType.Error, res.Message);
      hideLoader();
    }
  };

  const onSubmitValidation = async () => {
    debugger;
    setFormErrors({});
    formErrorObj = {};
    if (
      AdditionalLoanParameter.AdditionalAmount > 0 &&
      AdditionalLoanParameter.AdditionalAmount == null
    ) {
      formErrorObj["additionalAmount_isEmpty"] = "Amount can not be empty";
    }
    else if (AdditionalLoanParameter.AdditionalAmount > 0 && AdditionalLoanParameter.AdditionalAmount != 10000) {
      formErrorObj["additionalAmount_isEmpty"] = "Sanction Amount is either 0 or 10000";
    }
    setFormErrors(formErrorObj);
  };

  const getPersonalDetailsByIdApiCallll = async () => {
    showLoader();
    let requestParams = loanParameters; // { MemberId: MemberId };
    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    );
    if (res.Message === "Ok" && res.Data !== null) {
      
      if (
        res?.Data?.Lrd_LoanAmount != 0 &&
        res?.Data?.Lrd_InstallmentPeriod != 0
      ) {
        if (
          [LoanStatus.LoanModule_PendingWithInternalTeam].includes(
            res?.Data?.Lrd_StatusId
          )
        ) {
          setForLongTermDisabled(false);
          if (res?.Data?.Lrd_LoanType == LoanTypeEnum.SHORTTERM) {
            setForLongTermDisabled(true);
          }
        } else if ([LoanStatus.LoanModule_PendingWithHrHOD].includes(
          res?.Data?.Lrd_StatusId
        )) {
          setForLongTermDisabled(true);
        }
        else {
          setForLongTermDisabled(true);
        }

        setLoanRequestId(res?.Data?.Lrd_Id);

        setAdditionalLoanParameter({
          ...AdditionalLoanParameter,
          LoanId: res?.Data?.Lrd_Id,
          MemberId: res?.Data?.MemberId,
          AdditionalAmount: res?.Data?.Lrd_AdditionalAmountByIntTeam,
        });

        if (
          [
            LoanStatus.LoanModule_RejectedByInternalTeam,
            LoanStatus.LoanModule_Draft,
          ].includes(res?.Data?.Lrd_StatusId)
        ) {
          setDisabledReason(false);
        } else if (
          [
            LoanStatus.LoanModule_AllSuretyApproved,
            LoanStatus.LoanModule_PendingWithInternalTeam,
            LoanStatus.LoanModule_LoanApplicationCancelledByMember,
            LoanStatus.LoanModule_LoanApplicationRejected,
            LoanStatus.LoanModule_MemberSignaturePending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_MemberAgreementRejected,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
            LoanStatus.LoanModule_DocumentGenerationPending,
            LoanStatus.LoanModule_LoanApplicationApproved,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
          ].includes(res?.Data?.Lrd_StatusId)
        ) {
          setDisabledReason(true);
        }
        setIsResetClicked(true);
        setDisabled(true);
        setButtonDisabled(true);
        setLoanAmount(res?.Data?.Lrd_LoanAmount);
        setLoanType(res?.Data?.Lrd_LoanType);
        if (res?.Data?.Lrd_LoanType === LoanTypeEnum.LONGTERM) {
          setRateOfInterest(res?.Data?.LtlRoi);
        } else {
          setRateOfInterest(res?.Data?.RateOfInterest);
        }
        setInstallments(res?.Data?.Lrd_InstallmentPeriod); //
        setFormDataOnEdit(res?.Data?.Lrd_Reason);
        setMemberNumber(res?.Data?.MemberNo);
        setAdditionalLoanAmount(res?.Data?.Lrd_AdditionalLoanAmount);
        setAdditionalLoanROI(res?.Data?.AltlRoi);
        setGiveableLoanAmount(res?.Data?.Lrd_GiveableLoanAmount);
        setAdditionalGiveableLoanAmount(res?.Data?.Lrd_AdditionalGiveableLoanAmount);
      }
      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    const regex = /^[0-9]+$/;
    if (field === "additionalAmount") {
      if (value === "" || regex.test(value)) {
        if (value.length > 5) {
          value = value.slice(0, 5);
        } else if (value > 10000) {
          value = 10000;
        }

        // setAdditionalAmount(value);
        setAdditionalLoanParameter({
          ...AdditionalLoanParameter,
          AdditionalAmount: value,
        });
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    let eventData = event.currentTarget;
    await onSubmitValidation();

    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (isEmpty) {
      setAnchorEl(eventData);
      // let param = {};

      // let resp = await APICall("postSuretyDetails", param);
      // if (resp?.Status == ApiStatus.OK) {
      //   notify(ToastType.Success, "Waiting for surety approval");
      //   getPersonalDetailsByIdApiCallll();
      // } else {
      //   notify(ToastType.Error, resp?.Message || "Please try again later.");
      //   return;
      // }
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="clearfix"></div>

      {/* <div className="col-lg-12 col-md-12 mt-3">
        <div className="row">
          <div className="col-lg-4 col-sm-4 col-xs-4"></div>
          <div
            className="col-lg-4 col-sm-4 col-xs-4"
            style={{ textAlign: "center" }}
          >
            Member No. {memberNumber ? memberNumber : "NOT AVAILABLE"}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4"></div>
        </div>
      </div> */}
      <div className="p-0">
        <div className="col-lg-12 col-md-12">
          <div
            className="row"
            style={{ marginLeft: "-30px", marginRight: "-30px" }}
          >
            <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group">
                <label> {loanType === LoanTypeEnum.LONGTERM ? "Long" : "Short"} Term Loan Amount</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  // value={(loanAmount  )}
                  value={(
                    (parseInt(loanAmount) || 0)
                  )
                    .toLocaleString("en-IN")}
                 // type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            {loanType === LoanTypeEnum.LONGTERM && (
              <div className="col-lg-3 col-sm-3 col-xs-3">
                <div className="form-group">
                  <label>Total Sanction Amount</label>
                  {/* <label>Additional Loan Amount</label> */}
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    value={AdditionalLoanParameter.AdditionalAmount}
                    onChange={(e) => handleTextEvent(e, "additionalAmount")}
                    onKeyPress={(e) => handleKeyPress(e)}
                    type="number"
                    isDisabled={forLongTermDisabled}
                  // onWheel={(e) => e.target.blur()}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["additionalAmount_isEmpty"]}
                  </p>
                </div>
              </div>
            )}

            <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group">
                <label>
                  {loanType === LoanTypeEnum.LONGTERM ? "Long" : "Short"} Term
                  ROI (%)
                </label>
                <InputForm
                  placeholder={""}
                  value={RateOfInterest + " %"}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group">
                <label>Period of Installments</label>
                <InputForm
                  placeholder={""}
                  value={installments + " Months"}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12 col-md-12">
          <div
            className="row"
            style={{ marginLeft: "-30px", marginRight: "-30px" }}
          >
            {loanType === LoanTypeEnum.LONGTERM && (
              <>
                <div className="col-lg-3 col-sm-3 col-xs-3 ">
                  <div className="form-group">
                    <label>Additional Long Term Amount</label>
                    <InputForm
                      placeholder={""}
                      value={AdditionalLoanAmount?.toLocaleString("en-IN")}
                      isDisabled={true}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-3 ">
                  <div className="form-group">
                    <label>Additional Long Term ROI (%)</label>
                    <InputForm
                      placeholder={""}
                      value={AdditionalLoanROI + " %"}
                      isDisabled={true}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-3 ">
                  <div className="form-group">
                    <label>Total Giveable Amount</label>
                    <InputForm
                      placeholder={""}
                      value={(
                        ((GiveableLoanAmount || 0)) +
                        ((AdditionalGiveableLoanAmount || 0) || 0)
                      ).toLocaleString("en-IN")}
                      isDisabled={true}
                    />
                  </div>
                </div>
                {/* <div className="col-lg-3 col-sm-3 col-xs-3 ">
                  <div className="form-group">
                    <label>Additional Long Term Giveable Amount</label>
                    <InputForm
                      placeholder={""}
                      value={AdditionalGiveableLoanAmount?.toString().replace(
                        /(\d)(?=(\d{2})+\d(?!\d))/g,
                        "$1,"
                      )}
                      isDisabled={true}
                    />
                  </div>
                </div> */}
              </>
            )}
            <div className="col-lg-3 col-sm-3 col-xs-3">
              <div className="form-group">
                <label>Reason</label>
                <SelectForm
                  options={reasonOption}
                  isMulti={false}
                  placeholder={""}
                  value={reason}
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <div>
            {state?.mode === MODES.EDIT && (
              <>
                <ButtonForm
                  className="mx-2"
                  id="cancel"
                  value={
                    <p>
                      <i className="far fa-times-circle"></i> Cancel
                    </p>
                  }
                  onClick={() => navigate("/LoanApprovalDashboard")}
                />
                <ButtonComponent
                  icon={"fas fa-check-double"}
                  value={"Verify"}
                  style={{ marginLeft: "10px" }}
                  id={"saveBtn"}
                  onClick={handleClick}
                ></ButtonComponent>
              </>
            )}
          </div>
        </div>
        <>
          <ApprovalModal
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            loanParam={AdditionalLoanParameter}
            module={Modules.LoanModuleApproval}
          />
        </>
      </div>
    </>
  );
};

export default LoanDetailApproval;
